export default "__VITE_ASSET__kuzVYTUa__"